import {createTheme} from "@mui/material/styles";

export const MuiThemeCustomized = createTheme({
  palette: {
    primary: {
      main: '#ee7623',
      dark : '#c05e1d',
      contrastText: '#fff'
    }, secondary: {
      main: '#A35B95',
      dark : '#A35B95',
      contrastText: '#fff'
    },
  },
  components: {
    // MUI's own default is uppercase text on every Button. Nowhere in this app actually wants
    // that - every place that noticed got its own local ".MuiButton-root { text-transform: none }"
    // override (the toolbar row, the section bar, the quote-type filter, ...), which is exactly
    // how a button like DETAILS or CHANGE DATES - just outside any of those specific scopes -
    // ends up uppercase while its neighbors don't. One theme-level default replaces the whole
    // scattered, easy-to-miss pattern.
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none' },
      },
    },
  },
});